import AppModal from './AppModal.vue';
export default AppModal;



// WEBPACK FOOTER //
// ./src/uikit/components/AppModal/index.ts